import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_URL;

const updateTagLegal = async (id, data) => {
  return await axios.put(`${API_URL}/stock-api/${id}`, data, {
    headers: authHeader(),
  });
};

export default {
  updateTagLegal,
};
